<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToBrief()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">
                        Brief Auto-Hire Configuration
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">{{ brief() ? brief()!.title : 'Loading...' }}</p>
            </div>
        </div>

        <button type="button" (click)="showHelp.set(!showHelp())" class="z-10 rounded-full bg-gray-200 dark:bg-white/10 px-2 py-1 text-xs font-semibold text-gray-700 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-white/5 hover:bg-gray-300 dark:hover:bg-white/15 cursor-pointer">What is
            this?</button>
    </div>


    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-start w-full overflow-hidden">
        <div class="overflow-y-auto scrollbar-transparent space-y-4 h-full w-full">
            <!-- Help Element -->
            @if (showHelp()) {
            <div
                class="flex flex-row items-start gap-4 w-full max-w-full py-5 px-6 bg-primary/10 dark:bg-[#1a1724] border border-[rgba(156,81,182,0.35)] rounded-xl shadow-[0_0_20px_rgba(156,81,182,0.08)]">
                <div
                    class="shrink-0 w-[60px] h-[60px] flex items-center justify-center bg-linear-to-br from-[#e91e8c] to-[#9c51b6] rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-white">
                        <path d="M12 8V4H8" />
                        <rect width="16" height="12" x="4" y="8" rx="2" />
                        <path d="M2 14h2" />
                        <path d="M20 14h2" />
                        <path d="M15 13v2" />
                        <path d="M9 13v2" />
                    </svg>
                </div>
                <div class="flex-1 min-w-0 flex flex-col gap-2">
                    <h4 class="m-0 text-lg font-bold text-gray-900 dark:text-white leading-tight">Auto-Hire Configuration</h4>
                    <p class="m-0 text-sm leading-normal text-gray-600 dark:text-[#cccccc]">
                        Configure the rules our AI uses to automatically approve creator applications. When a creator
                        applies and meets all your criteria, they'll be instantly hired without manual review.
                        <br />
                        <strong class="font-bold text-fuchsia-500">NB:</strong> Make sure to <strong
                            class="font-bold text-fuchsia-500">Save</strong> your changes to apply the enrichments.
                    </p>
                </div>
            </div>
            }
            <!-- Help Element - END -->

            <!-- Budget & Creator Count -->
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-emerald-400/10 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-emerald-400">
                            <path
                                d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
                            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Budget</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">Limit your budget and number of creators to
                            hire.</p>
                    </div>
                </div>

                <div class="p-2 flex flex-col gap-y-2">
                    <div class="w-full grid grid-cols-2 gap-x-2">
                        <article class="card-container-pale p-4 flex flex-col justify-between">
                            <div class="flex flex-col gap-y-2">
                                <label for="max-budget"
                                    class="text-sm font-medium text-gray-500 dark:text-gray-400">Maximum
                                    Budget</label>
                                <div
                                    class="flex items-center rounded-2xl bg-gray-100 dark:bg-gray-900/90 px-4 py-3 border border-gray-300 dark:border-white/10">
                                    <span class="text-gray-900 dark:text-white font-semibold text-lg shrink-0 mr-2">{{ getCurrencySymbol()
                                        }}</span>
                                    <input id="max-budget" type="text" inputmode="decimal" [value]="budgetValue() || ''"
                                        (input)="onBudgetInput($event)"
                                        class="flex-1 min-w-0 bg-transparent border-0 text-gray-900 dark:text-white text-lg font-bold placeholder-gray-500 dark:placeholder-gray-500 focus:outline-none focus:ring-0"
                                        placeholder="0" />
                                </div>
                                <p class="text-xs text-gray-500 dark:text-gray-400">Auto-pilot will never spend beyond
                                    this
                                    amount.</p>

                            </div>


                            <div class="flex flex-col justify-start gap-y-2">
                                <span class="text-sm text-gray-500 dark:text-gray-400">Quick presets:</span>
                                <div class="flex flex-row itms-center justify-start gap-x-3">
                                    @for (preset of quickPresets; track preset.creators) {
                                    <button type="button" (click)="onQuickPresetClick(preset.creators, preset.budget)"
                                        class="rounded-full px-4 py-1 text-sm font-medium border transition-colors {{
                                            isQuickPresetSelected(preset)
                                                ? 'bg-green-600 text-white border-green-500'
                                                : 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
                                        }}">
                                        {{ getCurrencySymbol() }}{{ preset.budget | number:'1.0-0' }}
                                    </button>
                                    }
                                </div>
                            </div>
                        </article>

                        <article
                            class="border border-green-500 bg-white/50 dark:bg-white/5 rounded-lg p-4 flex flex-col gap-y-3">
                            <div class="flex flex-row items-center gap-x-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5 text-green-500 shrink-0">
                                    <path d="m22 8-6 4 6 4V8Z" />
                                    <rect width="14" height="12" x="2" y="6" rx="2" ry="2" />
                                </svg>
                                <h2 class="text-base font-semibold text-green-500 m-0">Estimated Content Items</h2>
                            </div>
                            <div>
                                @if (getExactContentPieces() !== null) {
                                <p class="m-0 flex flex-wrap items-baseline gap-x-1.5">
                                    <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ getExactContentPieces() }}</span>
                                    <span class="text-sm text-gray-600 dark:text-gray-300">pieces of content</span>
                                </p>
                                @if (brief()?.currentPrice && getExactRatePerVideo() != null && getExactRatePerVideo()!
                                > 0) {
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400">Based on an average rate of {{
                                    getExactRatePerVideo()! |
                                    currency:brief()?.currentPrice?.currencyCode?.toUpperCase():'symbol':'1.0-0' }} per
                                    video</p>
                                } @else {
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400">Based on an average rate of — per video</p>
                                }
                                } @else {
                                @if (getMinContentPieces() === getMaxContentPieces() && getMaxContentPieces() > 0) {
                                <p class="m-0 flex flex-wrap items-baseline gap-x-1.5">
                                    <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ getMaxContentPieces() }}</span>
                                    <span class="text-sm text-gray-600 dark:text-gray-300">pieces of content</span>
                                </p>
                                } @else if (getMaxContentPieces() > 0) {
                                <p class="m-0 flex flex-wrap items-baseline gap-x-1.5">
                                    <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ getMinContentPieces() }} <span
                                            class="text-sm text-secondary font-normal"> to </span> {{
                                        getMaxContentPieces() }}</span>
                                    <span class="text-sm text-gray-600 dark:text-gray-300">pieces of content</span>
                                </p>
                                } @else {
                                <p class="m-0 flex flex-wrap items-baseline gap-x-1.5">
                                    <span class="text-2xl font-bold text-gray-900 dark:text-white">—</span>
                                    <span class="text-sm text-gray-600 dark:text-gray-300">pieces of content</span>
                                </p>
                                }
                                @if (brief()?.currentPrice && (getMinRatePerVideo() > 0 || getMaxRatePerVideo() > 0)) {
                                @if (getMinRatePerVideo() === getMaxRatePerVideo()) {
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400">Based on an average rate of {{
                                    getMinRatePerVideo() |
                                    currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0' }} per
                                    video</p>
                                } @else {
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400">Based on rates from {{ getMinRatePerVideo() |
                                    currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0' }} to {{
                                    getMaxRatePerVideo() |
                                    currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0' }} per
                                    video</p>
                                }
                                } @else {
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400">Based on rates from — to — per video</p>
                                }
                                }
                                <p class="m-0 mt-1 text-sm text-gray-500 dark:text-gray-400"><span
                                        class="text-sm text-primary font-normal">NB: </span>Rates depend on the
                                    creator's rank and audience size.</p>
                            </div>
                            <div class="border-t border-gray-200 dark:border-gray-600 pt-3 flex flex-col gap-y-1.5">
                                @if (getExactContentPieces() !== null && getExactRatePerVideo() != null) {
                                <div class="flex flex-row justify-between text-sm text-gray-500 dark:text-gray-400">
                                    <span>Budget per video:</span>
                                    <span>~{{ getExactRatePerVideo()! |
                                        currency:brief()?.currentPrice?.currencyCode?.toUpperCase():'symbol':'1.0-0'
                                        }}</span>
                                </div>
                                } @else if (brief()?.currentPrice && (getMinRatePerVideo() > 0 || getMaxRatePerVideo() >
                                0)) {
                                @if (getMinRatePerVideo() === getMaxRatePerVideo()) {
                                <div class="flex flex-row justify-between text-sm text-gray-500 dark:text-gray-400">
                                    <span>Budget per video:</span>
                                    <span>~{{ getMinRatePerVideo() |
                                        currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0'
                                        }}</span>
                                </div>
                                } @else {
                                <div class="flex flex-row justify-between text-sm text-gray-500 dark:text-gray-400">
                                    <span>Budget per video:</span>
                                    <span>~{{ getMinRatePerVideo() |
                                        currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0' }}
                                        to ~{{ getMaxRatePerVideo() |
                                        currency:brief()!.currentPrice.currencyCode?.toUpperCase():'symbol':'1.0-0'
                                        }}</span>
                                </div>
                                }
                                } @else {
                                <div class="flex flex-row justify-between text-sm text-gray-500 dark:text-gray-400">
                                    <span>Budget per video:</span>
                                    <span>—</span>
                                </div>
                                }
                                <div class="flex flex-row justify-between text-sm">
                                    <span class="text-gray-500 dark:text-gray-400">Total budget:</span>
                                    <span class="text-green-500 font-medium">{{ budgetValue() |
                                        currency:brief()?.currentPrice?.currencyCode?.toUpperCase():'symbol':'1.0-0'
                                        }}</span>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
            <!-- Budget & Creator Count - END -->


            <!-- Followers -->
            <!-- @if (brief() && brief()!.shoutBrief && brief()!.shoutBrief!.crossPlatforms && brief()!.shoutBrief!.crossPlatforms!.length > 0) {
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-primary/15 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-accent">
                            <path d="M18 21a8 8 0 0 0-16 0" />
                            <circle cx="10" cy="8" r="5" />
                            <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Followers</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">Set the required following size ranges that
                            you require for this brief.</p>
                    </div>
                </div>

                <div class="p-2 grid grid-cols-3 gap-x-2">
                    @for (channel of channels; track channel.id) {
                    <div class="card-container-pale">
                        <div class="flex items-center gap-x-2 pb-2">
                            <img class="h-4 w-4 sm:h-6 sm:w-6 rounded-md" [src]="getRowIcon(channel.id)" alt>
                            <span class="text-sm font-semibold text-gray-900 dark:text-white">{{ channel.label }}</span>
                        </div>
                        <label class="block text-xs font-medium text-gray-500 dark:text-gray-400">Influencer
                            Tier</label>
                        @if (getInfluencerLevels().length) {

                        <el-select id="select" name="selected" [value]="getSelectedLevelIndexForChannel(channel.id)"
                            class="mt-2 block">
                            <button type="button"
                                class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                                <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">{{
                                    getSelectedLevelForChannel(channel.id) ?
                                    formatLevelLabel(getSelectedLevelForChannel(channel.id)!) : 'Select a level' }}
                                </el-selectedcontent>
                                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                                    <path
                                        d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </button>

                            <el-options anchor="bottom start" popover
                                [value]="getSelectedLevelIndexForChannel(channel.id)"
                                class="max-h-60 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                                @for (level of getInfluencerLevels(); track level.followersFrom + '-' +
                                level.followersTo) {
                                <el-option [value]="$index"
                                    (click)="onInfluencerLevelIndexChange(channel.id, $index.toString())"
                                    class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                    <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{
                                        formatLevelLabel(level) }}</span>
                                    <span
                                        class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="size-5">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </span>
                                </el-option>
                                }
                            </el-options>
                        </el-select>
                        @if (getSelectedLevelForChannel(channel.id); as level) {
                        <div class="mt-2 space-y-1 text-sm">
                            <p class="text-gray-600 dark:text-gray-300">Bonus: <span
                                    class="font-medium text-emerald-600 dark:text-emerald-400">{{ getCurrencySymbol()
                                    }}{{ (level.bonusValue / 100) | number:'1.0-0' }}</span></p>
                        </div>
                        }
                        } @else {
                        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">No influencer levels configured.</p>
                        }
                    </div>
                    }
                </div>
            </div>
            } -->
            <!-- Followers - END -->



            <!-- Followers - V2 (single platform from shoutBrief) -->
            <!-- @if (brief()?.shoutBrief && brief()?.shoutBrief?.crossPlatforms && brief()?.shoutBrief?.crossPlatforms == []
            && hasInfluencerSizePlatform() && getShoutBriefChannel(); as channel) { -->
            @if (hasInfluencerSizePlatform() && getShoutBriefChannel(); as channel) {
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-primary/15 rounded-md">
                        <img class="size-6 rounded-md object-contain" [src]="getRowIcon(channel)"
                            [alt]="getShoutBriefChannelLabel()" />
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Influencer size</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">Select the required following size for
                            {{ getShoutBriefChannelLabel() }}.</p>
                    </div>
                </div>

                <ul role="list" class="p-2 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
                    @for (level of getInfluencerLevels(); track level.followersFrom + '-' + level.followersTo; let i =
                    $index) {
                    <li (click)="onInfluencerLevelIndexChange(channel, i.toString())"
                        class="col-span-1 flex rounded-md shadow-xs dark:shadow-none hover:cursor-pointer">
                        <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white"
                            [class.bg-primary]="getSelectedLevelIndexForChannel(channel) === i"
                            [class.bg-emerald-500]="getSelectedLevelIndexForChannel(channel) !== i">
                            +{{ getCurrencySymbol() }}{{ (level.bonusValue / 100) | number:'1.0-0' }}
                        </div>
                        <div
                            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white/50 dark:border-white/10 dark:bg-white/5">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a
                                    class="font-medium text-gray-900 hover:text-gray-600 dark:text-white dark:hover:text-gray-200">{{
                                    level.title }}</a>
                                <p class="text-gray-500 dark:text-gray-400">{{
                                    formatService.convertIntToString(level.followersFrom) }} to {{
                                    formatService.convertIntToString(level.followersTo) }}</p>
                            </div>
                            <div class="shrink-0 pr-2 h-full flex flex-col items-center justify-center">

                                @if (getSelectedLevelIndexForChannel(channel) === i) {
                                <span
                                    class="flex items-center justify-center size-5 rounded-full bg-primary text-white"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M20 6 9 17l-5-5" />
                                    </svg>
                                </span>
                                }
                            </div>
                        </div>
                    </li>
                    }
                </ul>
            </div>
            }
            <!-- Followers - V2 - END-->




            <!-- Demographics -->
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-rose-400/10 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-rose-400">
                            <path d="M21.54 15H17a2 2 0 0 0-2 2v4.54" />
                            <path
                                d="M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17" />
                            <path d="M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" />
                            <circle cx="12" cy="12" r="10" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Creator Demographics</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">Set your preferences for Creator
                            demographics.</p>
                    </div>
                </div>

                <div class="p-2 w-full grid grid-cols-3 gap-x-2">

                    <article
                        class="card-container-pale col-span-1 divide-y divide-gray-200 dark:divide-white/10 overflow-hidden">
                        <div class="pb-2 flex flex-row items-center gap-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-primary">
                                <path d="M8 2v4" />
                                <path d="M16 2v4" />
                                <rect width="18" height="18" x="3" y="4" rx="2" />
                                <path d="M3 10h18" />
                            </svg>
                            <h2 class="text-primary">Age Range</h2>
                        </div>
                        <div class="p-2">
                            <!-- <ul class="w-full flex flex-col gap-y-2 pt-2"> -->
                            <ul class="w-full grid grid-cols-2 gap-2 pt-2">
                                @for (age of briefService.creatorAges; track age.id) {
                                <button type="button"
                                    class="w-full flex justify-between gap-x-4 py-2 px-2 rounded-md border text-left cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
                                    [class]="isAgeSelected(age) ? 'border-primary' : 'border-gray-200 dark:border-white/10'"
                                    (click)="onAgeToggle(age)">
                                    <dt [class]="isAgeSelected(age) ? 'text-primary' : 'text-secondary'">{{ age.label }}
                                    </dt>
                                    <dd class="shrink-0">
                                        @if (isAgeSelected(age)) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-accent">
                                            <path d="M20 6 9 17l-5-5" />
                                        </svg>
                                        }
                                    </dd>
                                </button>
                                }
                            </ul>
                        </div>
                    </article>
                    <article
                        class="card-container-pale col-span-1 divide-y divide-gray-200 dark:divide-white/10 overflow-hidden">
                        <div class="pb-2 flex flex-row items-center gap-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-primary">
                                <path d="M18 11c-1.5 0-2.5.5-3 2" />
                                <path
                                    d="M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z" />
                                <path d="M6 11c1.5 0 2.5.5 3 2" />
                            </svg>
                            <h2 class="text-primary">Preferred Gender</h2>
                        </div>
                        <div class="p-2">
                            <ul class="w-full flex flex-col gap-y-2 pt-2">
                                @for (gender of briefService.creatorGenders; track gender.id) {
                                <button type="button"
                                    class="w-full flex justify-between gap-x-4 py-2 px-2 rounded-md border text-left cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
                                    [class]="isGenderSelected(gender) ? 'border-primary' : 'border-gray-200 dark:border-white/10'"
                                    (click)="onGenderToggle(gender)">
                                    <dt [class]="isGenderSelected(gender) ? 'text-primary' : 'text-secondary'">{{
                                        gender.name }}</dt>
                                    <dd class="shrink-0">
                                        @if (isGenderSelected(gender)) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-accent">
                                            <path d="M20 6 9 17l-5-5" />
                                        </svg>
                                        }
                                    </dd>
                                </button>
                                }
                            </ul>
                        </div>
                    </article>

                    <article
                        class="card-container-pale col-span-1 divide-y divide-gray-200 dark:divide-white/10 overflow-hidden">
                        <div class="pb-2 flex flex-row items-center gap-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-primary">
                                <path
                                    d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            <h2 class="text-primary">Creator Location</h2>
                        </div>
                        <div class="p-2">
                            <ul class="w-full flex flex-col gap-y-2 pt-2">
                                @for (country of briefService.countryCodes; track country.countryCode) {
                                <button type="button"
                                    class="w-full flex justify-between gap-x-4 py-2 px-2 rounded-md border text-left cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
                                    [class]="isCountrySelected(country) ? 'border-primary' : 'border-gray-200 dark:border-white/10'"
                                    (click)="onCountryToggle(country)">
                                    <dt [class]="isCountrySelected(country) ? 'text-primary' : 'text-secondary'">{{
                                        country.countryName }}</dt>
                                    <dd class="shrink-0">
                                        @if (isCountrySelected(country)) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-accent">
                                            <path d="M20 6 9 17l-5-5" />
                                        </svg>
                                        }
                                    </dd>
                                </button>
                                }
                            </ul>
                        </div>
                    </article>
                </div>
            </div>
            <!-- Demographics - END -->

            <!-- Niches -->
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-yellow-400/10 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-yellow-400">
                            <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Creator Niches</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">Set your preferences for Creator
                            niches. (The general theme of the social accounts)</p>
                    </div>
                </div>

                <div class="p-2 flex flex-wrap gap-2">
                    @for (interest of briefService.creatorInterests; track interest.id) {
                    <button type="button"
                        class="inline-flex items-center gap-x-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors border cursor-pointer"
                        [class]="isInterestSelected(interest) ? 'border-primary bg-primary/10 text-accent dark:bg-primary/20' : 'border-gray-200 dark:border-white/10 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-white/5'"
                        (click)="onInterestToggle(interest)">
                        @if (interest.icon?.name) {
                        <span class="text-base" aria-hidden="true">{{ interest.icon?.name }}</span>
                        }
                        <span>{{ interest.name }}</span>
                        @if (isInterestSelected(interest)) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4 text-accent shrink-0">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                        }
                    </button>
                    }
                </div>
            </div>
            <!-- Niches - END -->

            <!-- Auto-Hire Criteria Rules -->
            <div
                class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <div class="flex space-x-3 p-2">
                    <div class="shrink-0 size-10 flex items-center justify-center bg-blue-400/10 rounded-md">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-blue-400">
                            <path d="M9 11l3 3L22 4"/>
                            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Auto-Hire Criteria Rules</h3>
                        <p class="text-sm text-gray-500 dark:text-gray-400">View and manage your auto-hire approval rules.</p>
                    </div>
                </div>

                <div class="p-4">
                    @if (getSelectedDemographics(); as demographics) {
                    @if (demographics.gender.length > 0 || demographics.interests.length > 0 || demographics.age.length > 0 || (demographics?.countryCodes?.length ?? 0) > 0) {
                    <div class="space-y-2">
                        @if (demographics.gender.length > 0) {
                        <div class="flex items-center gap-2 text-sm">
                            <span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-primary/10 dark:bg-primary/20 text-accent">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path d="M18 11c-1.5 0-2.5.5-3 2"/>
                                    <path d="M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z"/>
                                    <path d="M6 11c1.5 0 2.5.5 3 2"/>
                                </svg>
                                Gender: {{ demographics.gender.length }} selected
                            </span>
                        </div>
                        }
                        @if (demographics.interests.length > 0) {
                        <div class="flex items-center gap-2 text-sm">
                            <span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-yellow-100 dark:bg-yellow-500/20 text-yellow-700 dark:text-yellow-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
                                </svg>
                                Niches: {{ demographics.interests.length }} selected
                            </span>
                        </div>
                        }
                        @if (demographics.age.length > 0) {
                        <div class="flex items-center gap-2 text-sm">
                            <span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-rose-100 dark:bg-rose-500/20 text-rose-700 dark:text-rose-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path d="M8 2v4"/>
                                    <path d="M16 2v4"/>
                                    <rect width="18" height="18" x="3" y="4" rx="2"/>
                                    <path d="M3 10h18"/>
                                </svg>
                                Age ranges: {{ demographics.age.length }} selected
                            </span>
                        </div>
                        }
                        @if ((demographics.countryCodes?.length ?? 0) > 0) {
                        <div class="flex items-center gap-2 text-sm">
                            <span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-orange-100 dark:bg-orange-500/20 text-orange-700 dark:text-orange-300">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>
                                    <circle cx="12" cy="10" r="3"/>
                                </svg>
                                Locations: {{ demographics.countryCodes?.length ?? 0 }} selected
                            </span>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center py-8 text-center border border-dashed border-zinc-200 dark:border-zinc-700 rounded-xl">
                        <div class="flex items-center justify-center size-10 rounded-xl bg-zinc-100 dark:bg-zinc-800/40 mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 text-zinc-400 dark:text-zinc-500">
                                <path d="M9 11l3 3L22 4"/>
                                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                            </svg>
                        </div>
                        <p class="text-sm font-medium text-primary">No criteria added</p>
                        <p class="mt-0.5 text-xs text-secondary max-w-[180px]">Add auto-hire criteria to automatically approve matching applicants.</p>
                    </div>
                    }
                    }
                </div>
            </div>
            <!-- Auto-Hire Criteria Rules - END -->


        </div>
    </div>
    <!-- Main Content - END -->

    <div class="shrink-0 flex flex-row items-center justify-between w-full">

        <div class="flex items-center justify-between gap-3">
            <div
                class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                <span
                    class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                <input id="annual-billing" type="checkbox" name="annual-billing" aria-labelledby="annual-billing-label"
                    aria-describedby="annual-billing-description"
                    [checked]="brief()?.enableAutoPilot ?? false"
                    (change)="toggleAutoPilot($event)"
                    class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
            </div>

            <div class="text-sm inline-flex items-center gap-x-1">
                @if (brief() && brief()!.enableAutoPilot) {
                <label id="annual-billing-label" class="font-medium text-gray-900 dark:text-white">Auto-Pilot
                    Enabled</label>
                } @else {
                <label id="annual-billing-label" class="font-medium text-gray-900 dark:text-white">Auto-Pilot
                    Disabled</label>
                <span id="annual-billing-description" class="text-gray-500 dark:text-gray-400">(Enable Auto-Pilot to
                    start auto-hiring creators)</span>
                }
            </div>
        </div>


        <!-- @if (brief() && brief()!.enableAutoPilot) {

        } @else {

        } -->
        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
            <button (click)="saveAutoHireConfig()" type="button"
                class="inline-flex items-center gap-x-1.5 rounded-full bg-linear-to-br from-[#e91e8c] to-[#9c51b6] px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:cursor-pointer">
                Save Auto-Hire Config
                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-0.5 size-5">
                    <path
                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>